export default __webpack_public_path__ + "static/media/team_unstructured_avatar-01.f4c021d8.png";